module.exports = __webpack_public_path__ + "img/Feature.73d858af.jpg";